import React from "react";

import Header from "./header";
import Footer from "./footer";

const Main = (props) => (
  <React.Fragment>
    <Header />
    {props.children}
    <Footer />
  </React.Fragment>
);

export default Main;
